import { alertConstants } from '../_constants';

export const alertActions = {
  success,
  failure,
  clear,
  resetStore
}

function success(message) {
  return { type: alertConstants.SUCCESS, message }
}

function failure(message) {
  return { type: alertConstants.FAILURE, message }
}

function clear() {
  return { type: alertConstants.CLEAR }
}

function resetStore() {
  return dispatch => {
    return dispatch({type: alertConstants.RESET_STORE});
  }
}